import React, {Component} from 'react';
import {connect} from "react-redux";
import { Switch, Route } from 'react-router-dom';

import './index.scss';

import * as routes from '../../constants/routes';

//components
import PersonalMenu from './personal_menu';
import PersonalDetails from './personal_details';
import CreditCards from './credit_cards';
import Address from './address';
import Orders from './orders';
import Order from './order';


class PersonalZone extends Component{

    render(){
        const isDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';

        if (!this.props.userData){
            this.props.history.push(routes.home);
        }

        return(
            <section className='personal-zone'>
                <PersonalMenu />
                <Switch>
                    <Route exact path = { routes.personal_zone + routes.personal_zone_routes.my_orders + '/:id'} component={ Order } />
                    <Route exact path = { routes.personal_zone + routes.personal_zone_routes.my_orders} component={ Orders } />
                    <Route exact path = { routes.personal_zone + routes.personal_zone_routes.personal_details} component={ PersonalDetails } />
                    <Route exact path = { routes.personal_zone + routes.personal_zone_routes.address} component={ Address } />
                    <Route exact path = { routes.personal_zone + routes.personal_zone_routes.payment_methods} component={ CreditCards } />
                    { isDesktop &&
                        <Route path = { routes.personal_zone } component={ (Orders) } />
                    }
                </Switch>
            </section>
        )
    }
}


//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        userData: store.config.UserData,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(PersonalZone);